<template>
  <div class="responsive-table-container">
    <table id="custom-table">
      <thead class="custom-thead">
        <tr class="custom-tr">
          <th class="custom-th checkbox-cell">
            <img
              class="checkbox-active"
              src="/assets/data-table-icons/check-box-icon.svg"
              alt="Checkbox"
            />
          </th>
          <th class="custom-th" v-for="(column, index) in columns" :key="index">
            <div class="header" @click="() => changeSort(column)">
              <div class="header-text">
                {{ column.label }}
              </div>
              <div v-if="column.bind === dataOptions.sortField" class="header-sort-img">
                <img
                  class="sort-img"
                  :class="!dataOptions.ascending && 'active'"
                  src="/assets/data-table-icons/sort-icon.svg"
                  alt="Sort icon"
                />
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="custom-tbody">
        <tr
          class="row-data"
          v-for="dataItem in dataItems"
          :key="dataItem.id"
          @click="selectable && $emit('select', dataItem)"
        >
          <td class="custom-td checkbox-cell">
            <img
              class="checkbox-body"
              src="/assets/data-table-icons/check-box-icon.svg"
              alt="Checkbox"
            />
          </td>
          <td class="custom-td" v-for="(column, index) in columns" :key="index">
            <component :is="column.cell">
              {{ dataItem[column.bind] }}
            </component>
          </td>
        </tr>
      </tbody>
      <tfoot class="custom-tfoot">
        <tr>
          <td class="custom-td" :colspan="columns.length + 1">
            <div class="footer-container">
              <select-dropdown-input
                @input="changePageSize"
                :options="pageSizes"
                :default="dataOptions.currentPageSize"
              />
              <div class="footer-number-of-dataitems">
                <div class="number-of-dataitems">
                  {{
                    dataOptions.currentPageSize
                      ? dataOptions.currentPageSize * (dataOptions.currentPage - 1) + 1
                      : 1
                  }}
                  -
                  {{
                    dataOptions.currentPageSize
                      ? dataOptions.currentPageSize * dataOptions.currentPage > dataCount
                        ? dataCount
                        : dataOptions.currentPageSize * dataOptions.currentPage
                      : dataCount
                  }}
                  of {{ dataCount }}
                </div>
              </div>
              <div class="footer-pagination">
                <div
                  class="pagination-arrow-container left"
                  :class="dataOptions.currentPage !== 1 && 'active'"
                  @click="dataOptions.currentPage !== 1 && changePage(dataOptions.currentPage - 1)"
                >
                  <img
                    class="pagination-arrow"
                    src="/assets/data-table-icons/arrow-left.svg"
                    alt="Go left"
                  />
                </div>
                <div
                  class="pagination-arrow-container right"
                  :class="dataOptions.currentPage !== maxPage && 'active'"
                  @click="
                    dataOptions.currentPage !== maxPage && changePage(dataOptions.currentPage + 1)
                  "
                >
                  <img
                    class="pagination-arrow"
                    src="/assets/data-table-icons/arrow-right.svg"
                    alt="Go right"
                  />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import TextCell from './cell-types/TextCell.vue'
import NumberCell from './cell-types/NumberCell.vue'
import SelectDropdownInput from './select-dropdown-input.vue'

export default {
  name: 'data-table',
  components: { TextCell, NumberCell, SelectDropdownInput },
  props: {
    dataItems: {
      type: Array,
      default: () => [],
    },
    dataCount: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    currentPageSize: {
      type: Number | null,
      default: null,
    },
    pageSizes: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
    sortField: {
      type: String,
      default: 'id',
    },
    ascending: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataOptions: {
        currentPageSize: this.currentPageSize,
        currentPage: this.currentPage,
        sortField: this.sortField,
        ascending: this.ascending,
      },
    }
  },
  watch: {
    currentPage(val) {
      this.dataOptions.currentPage = val
    },
  },
  mounted() {
    if (!this.columns.length) {
      Object.keys(_.first(this.dataItems)).forEach(column =>
        this.columns.push({
          label: column,
          bind: column,
        }),
      )
    }
  },
  methods: {
    changePageSize(selectedPageSize) {
      this.dataOptions.currentPageSize = selectedPageSize !== 'All' ? selectedPageSize : null
      this.$emit('change-data', this.dataOptions)
    },
    changeSort(column) {
      if (this.dataOptions.sortField === column.bind) {
        this.dataOptions.ascending = !this.dataOptions.ascending
      } else {
        this.dataOptions.ascending = true
        this.dataOptions.sortField = column.bind
      }

      this.$emit('change-data', this.dataOptions)
    },
    changePage(newPage) {
      this.dataOptions.currentPage = newPage
      this.$emit('change-data', this.dataOptions)
    },
  },
}
</script>

<style scoped>
.responsive-table-container {
  width: 100%;
  overflow-x: auto;
}

#custom-table {
  width: 100%;
  height: 100%;
  border-spacing: 0;
  border: 2px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 0px 0px 8px 8px;
}

.custom-thead {
  background-color: #f5f5f5;
}

.custom-th {
  padding: 0.625rem 0.75rem;
}

.custom-th + .custom-th {
  padding-left: 1.25rem;
}

.header {
  display: flex;
  width: fit-content;
  align-items: center;
}

.header:hover {
  cursor: pointer;
}

.header-text {
  display: flex;
  justify-content: flex-start;
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #0277bd;
}

.header-sort-img {
  display: flex;
  margin-left: 0.25rem;
}

.sort-img {
  height: 0.875rem;
  width: 0.875rem;
  filter: invert(28%) sepia(78%) saturate(1943%) hue-rotate(182deg) brightness(93%) contrast(98%);
  transition: transform 0.1s linear;
}

.sort-img.active {
  transform: rotateX(180deg);
}

.custom-td {
  padding: 0.875rem 0.75rem;
}

.checkbox-cell {
  height: 100%;
  width: 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-cell > img:hover {
  cursor: pointer;
}

.checkbox-active {
  filter: invert(28%) sepia(78%) saturate(1943%) hue-rotate(182deg) brightness(93%) contrast(98%);
}

.checkbox-body {
  filter: invert(0%) sepia(0%) saturate(4055%) hue-rotate(156deg) brightness(106%) contrast(60%);
}

.custom-td + .custom-td {
  padding-left: 1.25rem;
}

.row-data:hover {
  background-color: rgba(2, 119, 189, 0.1);
  cursor: pointer;
}

.custom-tfoot .custom-td {
  border-top: 2px solid #f5f5f5;
  padding: 0.625rem 1.5rem;
}

.footer-container {
  display: flex;
  width: 100%;
  justify-content: end;
  align-items: center;
}

.footer-number-of-dataitems {
  margin: 0 3rem;
}

.number-of-dataitems {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #979797;
}

.footer-pagination {
  display: flex;
  align-items: center;
}

.pagination-arrow-container {
  display: flex;
  width: 1.25rem;
  height: 1.25rem;
  align-items: center;
  justify-content: center;
}

.pagination-arrow-container.right {
  margin-left: 1.5rem;
}

.pagination-arrow {
  width: 0.75rem;
  height: 0.75rem;
  filter: invert(61%) sepia(0%) saturate(50%) hue-rotate(154deg) brightness(98%) contrast(93%);
}

.pagination-arrow-container.active:hover {
  cursor: pointer;
}

.pagination-arrow-container.active:hover .pagination-arrow {
  filter: invert(10%) sepia(12%) saturate(0%) hue-rotate(153deg) brightness(91%) contrast(73%);
}
</style>
